import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { FadeIn } from '../components/ui/FadeIn';
export function PrivacyPolicyPage() {
  return <main className="min-h-screen w-full bg-white selection:bg-neutral-900 selection:text-white pt-24" data-id="element-175">
      <Navbar data-id="element-176" />

      <section className="px-6 py-12 md:py-20" data-id="element-177">
        <div className="max-w-3xl mx-auto" data-id="element-178">
          <FadeIn data-id="element-179">
            <h1 className="text-4xl md:text-5xl font-semibold tracking-tight text-neutral-900 mb-12" data-id="element-180">
              Privacy Policy
            </h1>

            <div className="space-y-10 text-neutral-600 leading-relaxed" data-id="element-181">
              <div data-id="element-182">
                <h2 className="text-2xl font-semibold text-neutral-900 mb-4" data-id="element-183">
                  Introduction
                </h2>
                <p data-id="element-184">
                  Stasis Group PTY LTD ("Stasis Group", "we", "us", or "our") is
                  committed to protecting your privacy. This policy explains how
                  we collect, use, and safeguard your personal information in
                  accordance with the Protection of Personal Information Act
                  (POPIA).
                </p>
              </div>

              <div data-id="element-185">
                <h2 className="text-2xl font-semibold text-neutral-900 mb-4" data-id="element-186">
                  Information We Collect
                </h2>
                <p className="mb-3" data-id="element-187">
                  We may collect the following information when you engage with
                  our services:
                </p>
                <ul className="list-disc pl-5 space-y-2" data-id="element-188">
                  <li data-id="element-189">
                    Name and contact details (email, phone number, company name)
                  </li>
                  <li data-id="element-190">Business information relevant to your project</li>
                  <li data-id="element-191">Payment and billing information</li>
                  <li data-id="element-192">Communications and correspondence</li>
                  <li data-id="element-193">Project requirements and business needs</li>
                  <li data-id="element-194">Browser information and website usage data</li>
                </ul>
              </div>

              <div data-id="element-195">
                <h2 className="text-2xl font-semibold text-neutral-900 mb-4" data-id="element-196">
                  How We Use Your Information
                </h2>
                <p className="mb-3" data-id="element-197">Your information is used to:</p>
                <ul className="list-disc pl-5 space-y-2" data-id="element-198">
                  <li data-id="element-199">Deliver and manage our software development services</li>
                  <li data-id="element-200">Communicate project updates and milestone progress</li>
                  <li data-id="element-201">Process payments and invoicing</li>
                  <li data-id="element-202">Improve our services and client experience</li>
                </ul>
                <p className="mt-4" data-id="element-203">
                  <strong data-id="element-204">We do not sell your personal information.</strong>
                </p>
              </div>

              <div data-id="element-205">
                <h2 className="text-2xl font-semibold text-neutral-900 mb-4" data-id="element-206">
                  Data Protection
                </h2>
                <p data-id="element-207">
                  We implement appropriate technical and organisational measures
                  to protect your personal information against unauthorised
                  access, alteration, disclosure, or destruction.
                </p>
              </div>

              <div data-id="element-208">
                <h2 className="text-2xl font-semibold text-neutral-900 mb-4" data-id="element-209">
                  Third Parties
                </h2>
                <p data-id="element-210">
                  We do not sell or share your personal information with third
                  parties, except where necessary to deliver our services (e.g.,
                  payment processors) or as required by law.
                </p>
              </div>

              <div data-id="element-211">
                <h2 className="text-2xl font-semibold text-neutral-900 mb-4" data-id="element-212">
                  Your Rights (POPIA Compliance)
                </h2>
                <p data-id="element-213">
                  Under POPIA, you have the right to access, correct, or request
                  deletion of your personal information. To exercise these
                  rights, contact us at hello@stasisgroup.co.
                </p>
              </div>

              <div className="pt-6 border-t border-neutral-100 text-sm text-neutral-400" data-id="element-214">
                <p data-id="element-215">Last updated: February 2026</p>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      <Footer data-id="element-216" />
    </main>;
}